(function () {
  const pbBrowniesRootsInited = new WeakSet();

  function pbFormatMoney(cents, formatStr) {
    if (typeof cents !== 'number' || !Number.isFinite(cents)) return '';
    const amount = (Math.round(cents) / 100).toFixed(2);
    const fmt = formatStr || '{{ amount }}';
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/gi, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, amount.replace('.', ','));
  }

  function pbGetQtyInput(root) {
    // The box-count pills drive this hidden input; fall back to a native quantity field.
    return root.querySelector('[data-pb-qty-input]') || root.querySelector('input[name="quantity"]');
  }

  function pbGetFormQuantity(root) {
    const input = pbGetQtyInput(root);
    if (!input) return 1;
    const n = parseInt(input.value, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function pbParseCents(v, fallback) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function pbAllocationPlanId(alloc) {
    if (!alloc) return '';
    if (alloc.selling_plan_id != null) return String(alloc.selling_plan_id);
    const sp = alloc.selling_plan;
    if (sp != null && sp.id != null) return String(sp.id);
    return '';
  }

  function pbApplyAllocationsToPlanOptions(plansEl, allocations) {
    const select = plansEl?.querySelector('.delivery-dropdown');
    if (!select || !Array.isArray(allocations)) return;
    const byPlan = new Map();
    for (let i = 0; i < allocations.length; i++) {
      const a = allocations[i];
      const pid = pbAllocationPlanId(a);
      if (pid) byPlan.set(pid, a);
    }
    for (let o = 0; o < select.options.length; o++) {
      const opt = select.options[o];
      const a = byPlan.get(String(opt.value));
      if (!a) continue;
      if (a.price != null) opt.dataset.pbPlanPriceCents = String(a.price);
      const cmp = a.compare_at_price;
      if (cmp != null) opt.dataset.pbPlanCompareCents = String(cmp);
    }
  }

  function pbSyncPurchaseFromSizeRadio(plansEl, radio) {
    if (!plansEl || !radio) return;
    const oc = radio.getAttribute('data-pb-onetime-price-cents');
    const cc = radio.getAttribute('data-pb-onetime-compare-cents');
    if (oc) plansEl.dataset.pbOnetimePriceCents = oc;
    if (cc) plansEl.dataset.pbOnetimeCompareCents = cc;
    const raw = radio.getAttribute('data-pb-allocations');
    let allocs = null;
    if (raw) {
      try {
        allocs = JSON.parse(raw);
      } catch (e) {
        allocs = null;
      }
    }
    pbApplyAllocationsToPlanOptions(plansEl, allocs);
  }

  function pbFormatPriceUnit(servings, qty, label) {
    const count = servings * qty;
    if (!label) return '';
    return '/' + count + ' ' + label;
  }

  // Sum the prices (cents) of any checked upsell cards. These are flat additions to the
  // order total — independent of box count / subscription — so they only affect the
  // Add to Cart grand total, not the per-box plan rows.
  function pbGetUpsellCents(root) {
    let sum = 0;
    root.querySelectorAll('[data-pb-upsell-item]').forEach((input) => {
      if (!input.checked) return;
      const c = parseInt(input.getAttribute('data-pb-upsell-price-cents'), 10);
      if (Number.isFinite(c)) sum += c;
    });
    return sum;
  }

  // Checked upsell cards → /cart/add.js line items (quantity 1 each).
  function pbGetCheckedUpsellItems(root) {
    const items = [];
    root.querySelectorAll('[data-pb-upsell-item]').forEach((input) => {
      if (!input.checked) return;
      const id = parseInt(input.getAttribute('data-pb-upsell-variant-id'), 10);
      if (Number.isFinite(id)) items.push({ id: id, quantity: 1 });
    });
    return items;
  }

  function pbCartAddUrl() {
    const base = (window.routes && routes.cart_add_url) || '/cart/add';
    return base.endsWith('.js') ? base : base + '.js';
  }

  function pbPostCartAdd(body) {
    return fetch(pbCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    }).then((response) => response.json());
  }

  function pbShowFormError(container, message) {
    const errWrap = container?.querySelector('.product-form__error-message-wrapper');
    const errMsg = errWrap?.querySelector('.product-form__error-message');
    if (!errWrap || !errMsg) return;
    errWrap.hidden = false;
    errMsg.textContent = message || 'Could not add to cart';
  }

  // product-form.js used to reset this for us via handleErrorMessage(); we own it now,
  // otherwise a stale error stays on screen through later successful adds.
  function pbClearFormError(container) {
    const errWrap = container?.querySelector('.product-form__error-message-wrapper');
    const errMsg = errWrap?.querySelector('.product-form__error-message');
    if (!errWrap || !errMsg) return;
    errWrap.hidden = true;
    errMsg.textContent = '';
  }

  function pbClearUpsellSelection(root) {
    root.querySelectorAll('[data-pb-upsell-item]').forEach((input) => {
      if (!input.checked) return;
      input.checked = false;
      const card = input.closest('.pb-pdp-upsell-card');
      if (card) card.classList.remove('is-selected');
    });
    pbUpdateDisplayedPurchasePrices(root);
    root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
  }

  // Build the main PDP line from the live form (variant, qty, selling plan).
  function pbGetMainCartItem(form, root) {
    const idInput = form.querySelector('[name="id"]');
    const id = parseInt(idInput?.value, 10);
    if (!Number.isFinite(id)) return null;

    const item = {
      id: id,
      quantity: pbGetFormQuantity(root),
    };

    const planInput = form.querySelector('[name="selling_plan"]');
    if (planInput && !planInput.disabled && planInput.value) {
      item.selling_plan = planInput.value;
    }

    return item;
  }

  // The whole add-to-cart: main product + any checked add-ons in ONE /cart/add.js call.
  async function pbSubmitMainPlusUpsells(root, container, upsellItems) {
    if (root.dataset.pbUpsellSubmitting === '1') return;

    pbClearFormError(container);

    const submitButton = container?.querySelector('.product-form__submit');
    const spinner = container?.querySelector('.loading__spinner');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const mainItem = pbGetMainCartItem(root, root);
    if (!mainItem) {
      pbShowFormError(container, 'Could not add to cart. Please refresh and try again.');
      return;
    }

    root.dataset.pbUpsellSubmitting = '1';
    submitButton?.setAttribute('aria-disabled', 'true');
    submitButton?.classList.add('loading');
    spinner?.classList.remove('hidden');

    try {
      // Same bundle guard as product-form.js — don't add if a BYOB parent is in cart.
      try {
        const res = await fetch('/cart.js');
        const cartJson = await res.json();
        const hasBundle = cartJson.items?.some(
          (item) => item.properties && item.properties._browniebundle_parent === true
        );
        if (hasBundle) {
          document.querySelector('.notify_popup--wrapper')?.classList.add('show');
          return;
        }
      } catch (e) {
        console.error('PB upsell cart check failed:', e);
        return;
      }

      const body = {
        items: [mainItem, ...upsellItems.map((i) => ({ id: i.id, quantity: i.quantity }))],
      };

      // Comma-joined, matching the bundle landing pages (pb-lp-product-buybox).
      const sectionIds =
        cart && typeof cart.getSectionsToRender === 'function'
          ? cart.getSectionsToRender().map((section) => section.id)
          : ['cart-drawer', 'cart-icon-bubble'];
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
      if (cart && typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }

      let data = await pbPostCartAdd(body);
      let upsellsAdded = true;

      // /cart/add.js is all-or-nothing: one unbuyable add-on line rejects the main
      // product with it. Never let an add-on break Add to Cart — report it and retry
      // with the main line only.
      if (data && data.status) {
        const reason = data.description || data.message;
        console.error('PB main+upsell add failed, retrying without add-ons:', reason);
        pbShowFormError(container, reason);
        upsellsAdded = false;
        data = await pbPostCartAdd(Object.assign({}, body, { items: [mainItem] }));
        if (data && data.status) {
          pbShowFormError(container, data.description || data.message);
          return;
        }
      }

      if (!cart) {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: String(mainItem.id),
          cartData: data,
        });
      }

      if (typeof cart.renderContents === 'function' && data.sections) {
        cart.renderContents(data);
      }

      // We've replaced product-form's handler on this submit, so keep its order-note
      // clear so the two ATC paths leave the cart in the same state.
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ note: '' }),
      }).catch((err) => console.error('Failed to clear order note:', err));

      if (upsellsAdded) pbClearUpsellSelection(root);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {
      console.error('PB main+upsell add error:', e);
    } finally {
      delete root.dataset.pbUpsellSubmitting;
      submitButton?.classList.remove('loading');
      submitButton?.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
      if (cart?.classList?.contains('is-empty')) cart.classList.remove('is-empty');
    }
  }

  // Keep the live total (and therefore the Add to Cart label) in sync when the product
  // has no subscription widget — base unit × box count + checked upsell add-ons.
  function pbUpdateLivePriceNoPlans(root) {
    const liveEl = root.querySelector('[data-pb-live-price]');
    if (!liveEl) return;
    const unit = pbParseCents(liveEl.dataset.pbUnitCents, 0);
    const qty = pbGetFormQuantity(root);
    const fmt = liveEl.dataset.pbMoneyFormat || '';
    liveEl.textContent = pbFormatMoney(unit * qty + pbGetUpsellCents(root), fmt);
  }

  function pbUpdateDisplayedPurchasePrices(root) {
    const plans = root.querySelector('[data-pb-purchase-options]');
    if (!plans) {
      // No subscription plans → the plan rows below don't exist, but the live total still
      // needs to reflect box count + upsell selections.
      pbUpdateLivePriceNoPlans(root);
      return;
    }

    const format = plans.dataset.pbMoneyFormat || '';
    const servings = pbParseCents(plans.dataset.pbServings, 12) || 12;
    const unitLabel = plans.dataset.pbUnitLabel || '';
    const qty = pbGetFormQuantity(root);
    const unitText = pbFormatPriceUnit(servings, qty, unitLabel);

    const subscribeRadio = plans.querySelector('#subscribe-save');
    const isSubscribe = Boolean(subscribeRadio?.checked);

    const onetimeUnit = pbParseCents(plans.dataset.pbOnetimePriceCents, 0);
    const onetimeCompareUnit = pbParseCents(plans.dataset.pbOnetimeCompareCents, onetimeUnit);

    const deliveryDropdown = plans.querySelector('.delivery-dropdown');
    const selectedOpt = deliveryDropdown?.selectedOptions?.[0];

    let unitCents;
    if (isSubscribe && selectedOpt) {
      unitCents = pbParseCents(
        selectedOpt.dataset.pbPlanPriceCents,
        pbParseCents(plans.dataset.pbOnetimePriceCents, 0)
      );
    } else {
      unitCents = onetimeUnit;
    }

    const totalCents = unitCents * qty;

    const subValueEl = plans.querySelector('.pb-pdp-plan__price--subscribe .pb-pdp-plan__price-value');
    const subServingEl = plans.querySelector('.pb-pdp-plan__price--subscribe .pb-pdp-plan__price-serving');

    const otCompareEl = plans.querySelector('.pb-pdp-plan__price--onetime .pb-pdp-plan__price-compare');
    const otValueEl = plans.querySelector('.pb-pdp-plan__price--onetime .pb-pdp-plan__price-value');
    const otServingEl = plans.querySelector('.pb-pdp-plan__price--onetime .pb-pdp-plan__price-serving');

    function paintSubscribeRow() {
      const u = selectedOpt
        ? pbParseCents(selectedOpt.dataset.pbPlanPriceCents, pbParseCents(plans.dataset.pbOnetimePriceCents, 0))
        : pbParseCents(plans.dataset.pbOnetimePriceCents, 0);
      // Main price reflects the full order (unit × box count); per-serving stays per-serving.
      if (subValueEl) subValueEl.textContent = pbFormatMoney(u * qty, format);
      if (subServingEl) {
        const per = servings > 0 ? Math.round(u / servings) : 0;
        subServingEl.textContent = pbFormatMoney(per, format) + ' / serving';
      }
    }

    function paintOnetimeRow() {
      const u = onetimeUnit;
      const c = onetimeCompareUnit;
      if (otCompareEl) {
        const show = c > u;
        otCompareEl.textContent = show ? pbFormatMoney(c * qty, format) : '';
        otCompareEl.hidden = !show;
      }
      if (otValueEl) otValueEl.textContent = pbFormatMoney(u * qty, format);
      if (otServingEl) {
        const per = servings > 0 ? Math.round(u / servings) : 0;
        otServingEl.textContent = pbFormatMoney(per, format) + ' / serving';
      }
    }

    paintSubscribeRow();
    paintOnetimeRow();

    plans.querySelectorAll('[data-pb-price-unit]').forEach((el) => {
      el.textContent = unitText;
    });

    const liveEl = root.querySelector('[data-pb-live-price]');
    if (liveEl) {
      const fmt = plans.dataset.pbMoneyFormat || liveEl.dataset.pbMoneyFormat || '';
      // Grand total = main product (unit × box count) + any checked upsell add-ons.
      liveEl.textContent = pbFormatMoney(totalCents + pbGetUpsellCents(root), fmt);
    }
  }

  function initUpsell(root) {
    const upsell = root.querySelector('[data-pb-upsell]');
    if (!upsell) {
      return;
    }

    upsell.querySelectorAll('.pb-pdp-upsell-card').forEach((card) => {
      const input = card.querySelector('[data-pb-upsell-item]');
      if (!input) return;

      const syncSelected = () => {
        card.classList.toggle('is-selected', input.checked);
        card.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      };

      // Cards are <div>s (not <label>) so a horizontal scroller does not eat the first
      // click as focus/scroll intent. We toggle the checkbox ourselves.
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      syncSelected();

      const toggle = () => {
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      let pointerStart = null;
      card.addEventListener('pointerdown', (e) => {
        pointerStart = { x: e.clientX, y: e.clientY };
      });

      card.addEventListener('click', (e) => {
        // Ignore scroll-drags inside the upsell scroller.
        if (pointerStart) {
          const dx = Math.abs(e.clientX - pointerStart.x);
          const dy = Math.abs(e.clientY - pointerStart.y);
          pointerStart = null;
          if (dx > 8 || dy > 8) return;
        }
        e.preventDefault();
        toggle();
      });

      card.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        toggle();
      });

      input.addEventListener('change', () => {
        syncSelected();
        pbUpdateDisplayedPurchasePrices(root);
        root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
      });
    });

    // Edge fade hint: fade whichever side still has content to scroll toward.
    const scroller = upsell.querySelector('[data-pb-upsell-scroller]');
    if (scroller) {
      const updateFades = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        const x = scroller.scrollLeft;
        const hasOverflow = maxScroll > 1;
        scroller.classList.toggle('is-fade-start', hasOverflow && x > 1);
        scroller.classList.toggle('is-fade-end', hasOverflow && x < maxScroll - 1);
      };
      scroller.addEventListener('scroll', updateFades, { passive: true });
      window.addEventListener('resize', updateFades);
      updateFades();
    }

    // Checked cards are read at click time by initAjaxAtc — this function only owns the
    // row's own UI (selected state, price total, edge fades).
  }

  // The only add-to-cart path on this PDP. The buy buttons render no <form> and no
  // <product-form> (pb-pdp-buy-buttons-ajax.liquid), so nothing else is listening and
  // there is no submit event to lose — we always build the line items and POST them
  // ourselves, exactly like the bundle landing pages.
  function initAjaxAtc(root) {
    const container = root.querySelector('[data-pb-atc]');
    if (!container) {
      return;
    }

    const btn = container.querySelector('.product-form__submit');
    if (!btn) {
      return;
    }
    if (btn.dataset.pbAtcBound === 'true') return;
    btn.dataset.pbAtcBound = 'true';

    btn.addEventListener('click', (evt) => {
      evt.preventDefault();
      const upsellItems = pbGetCheckedUpsellItems(root);
      pbSubmitMainPlusUpsells(root, container, upsellItems);
    });
  }

  function initGallery(root) {
    const track = root.querySelector('[data-pb-gallery-track]');
    const slides = root.querySelectorAll('[data-pb-gallery-slide]');
    const dots = root.querySelectorAll('[data-pb-gallery-dot]');
    const thumbs = root.querySelectorAll('[data-pb-gallery-thumb]');
    const thumbStrip = root.querySelector('[data-pb-gallery-thumbs]');
    const prev = root.querySelector('[data-pb-gallery-prev]');
    const next = root.querySelector('[data-pb-gallery-next]');
    const viewport = root.querySelector('[data-pb-gallery-viewport]');

    if (!track || !slides.length) return;

    let index = 0;
    let touchStartX = 0;
    let touchDeltaX = 0;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';
      dots.forEach((dot, n) => {
        dot.classList.toggle('is-active', n === index);
        dot.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      thumbs.forEach((thumb, n) => {
        thumb.classList.toggle('is-active', n === index);
        thumb.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      scrollActiveThumbIntoView();
    }

    function scrollActiveThumbIntoView() {
      if (!thumbStrip) return;
      const active = thumbs[index];
      if (!active) return;
      const pad = 8;
      const left = active.offsetLeft;
      const right = left + active.offsetWidth;
      const viewLeft = thumbStrip.scrollLeft;
      const viewRight = viewLeft + thumbStrip.clientWidth;
      if (left < viewLeft) {
        thumbStrip.scrollTo({ left: Math.max(0, left - pad), behavior: 'smooth' });
      } else if (right > viewRight) {
        thumbStrip.scrollTo({ left: right - thumbStrip.clientWidth + pad, behavior: 'smooth' });
      }
    }

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot, n) => {
      dot.addEventListener('click', () => goTo(n));
    });
    thumbs.forEach((thumb, n) => {
      thumb.addEventListener('click', () => goTo(n));
    });

    if (viewport && slides.length > 1) {
      viewport.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'ArrowLeft') goTo(index - 1);
          if (e.key === 'ArrowRight') goTo(index + 1);
        },
        false
      );

      viewport.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
          touchDeltaX = 0;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        (e) => {
          touchDeltaX = e.changedTouches[0].screenX - touchStartX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        () => {
          if (Math.abs(touchDeltaX) < 40) return;
          if (touchDeltaX < 0) goTo(index + 1);
          else goTo(index - 1);
        },
        { passive: true }
      );
    }

    goTo(0);
  }

  function initPurchaseOptions(root) {
    const plans = root.querySelector('[data-pb-purchase-options]');
    if (!plans) {
      // One-time-only: keep ATC / live total in sync when box-count quantity changes.
      pbGetQtyInput(root)?.addEventListener('input', () => {
        pbUpdateDisplayedPurchasePrices(root);
        root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
      });
      pbUpdateDisplayedPurchasePrices(root);
      return;
    }

    const subscribeRadio = plans.querySelector('#subscribe-save');
    const oneTimeRadio = plans.querySelector('#one-time');
    const deliveryDropdown = plans.querySelector('.delivery-dropdown');
    const sellingPlanInput = root.querySelector('[name="selling_plan"]');
    const subscribePlan = plans.querySelector('.pb-pdp-plan--subscribe');
    const onetimePlan = plans.querySelector('.pb-pdp-plan--onetime');

    function setSelectedState() {
      const isSubscribe = subscribeRadio?.checked;
      subscribePlan?.classList.toggle('is-selected', Boolean(isSubscribe));
      onetimePlan?.classList.toggle('is-selected', !isSubscribe);
    }

    function syncSellingPlan() {
      if (!sellingPlanInput) return;

      if (subscribeRadio?.checked && deliveryDropdown) {
        const selectedOption = deliveryDropdown.options[deliveryDropdown.selectedIndex];
        if (selectedOption) {
          sellingPlanInput.value = selectedOption.value;
          sellingPlanInput.removeAttribute('disabled');
        }
        const subSaveRadioButton = document.querySelector('[data-radio-subsave]');
        subSaveRadioButton?.click();
      } else {
        const oneTimeRadioButton = document.querySelector('[data-radio-onetime]');
        oneTimeRadioButton?.click();
        sellingPlanInput.setAttribute('disabled', 'disabled');
      }
    }

    function onPurchaseChange() {
      setSelectedState();
      syncSellingPlan();
      pbUpdateDisplayedPurchasePrices(root);
      root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
    }

    plans.querySelectorAll('input[name="purchase-option"]').forEach((radio) => {
      radio.addEventListener('change', onPurchaseChange);
    });

    deliveryDropdown?.addEventListener('change', () => {
      syncSellingPlan();
      pbUpdateDisplayedPurchasePrices(root);
      root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
    });

    root.addEventListener('pb:static-size-change', () => {
      const staticWrap = root.querySelector('[data-pb-size-static]');
      const radio = staticWrap?.querySelector('.pb-pdp-size__input:checked');
      pbSyncPurchaseFromSizeRadio(plans, radio);
      pbUpdateDisplayedPurchasePrices(root);
      root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
    });

    pbGetQtyInput(root)?.addEventListener('input', () => {
      pbUpdateDisplayedPurchasePrices(root);
      root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function pbBrowniesOnVariantChange(pbPayload) {
        if (String(pbPayload?.data?.sectionId) !== String(root.dataset.section)) return;
        const variant = pbPayload?.data?.variant;
        if (!variant) return;
        plans.dataset.pbOnetimePriceCents = String(variant.price);
        plans.dataset.pbOnetimeCompareCents = String(
          variant.compare_at_price != null ? variant.compare_at_price : variant.price
        );
        pbApplyAllocationsToPlanOptions(plans, variant.selling_plan_allocations);
        pbUpdateDisplayedPurchasePrices(root);
        root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
      });
    }

    setSelectedState();
    syncSellingPlan();
    pbUpdateDisplayedPurchasePrices(root);
  }

  function initStaticSizePicker(root) {
    const staticSize = root.querySelector('[data-pb-size-static]');
    if (!staticSize) return;

    const qtyInput = pbGetQtyInput(root);
    const radios = staticSize.querySelectorAll('.pb-pdp-size__input');

    function applySize(radio) {
      if (!radio) return;

      // Box count = quantity of the single SKU to add (1 / 2 / 3 / 4 boxes …).
      // These pills are not product variants — they only drive quantity.
      const count = parseInt(radio.dataset.pbBoxCount, 10);
      if (qtyInput && Number.isFinite(count) && count > 0) {
        qtyInput.value = String(count);
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      root.dispatchEvent(new CustomEvent('pb:static-size-change', { bubbles: true }));
      pbUpdateDisplayedPurchasePrices(root);
      // When Subscribe & Save is disabled, `[data-pb-purchase-options]` is absent so
      // initPurchaseOptions never wires this event — fire it here so the ATC label
      // (and any other listeners) still refresh from the updated live total.
      root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) applySize(radio);
      });
    });

    const checked = staticSize.querySelector('.pb-pdp-size__input:checked');
    if (!checked) return;

    const count = parseInt(checked.dataset.pbBoxCount, 10);
    const currentQty = qtyInput ? parseInt(qtyInput.value, 10) : NaN;
    if (qtyInput && Number.isFinite(count) && count > 0 && currentQty === count) {
      return;
    }

    applySize(checked);
  }

  function initAtcLabel(root) {
    const btn = root.querySelector('.product-form__submit');
    if (!btn) return;

    const base = btn.dataset.pbAtcBase || 'Add to Cart';

    function syncLabel() {
      const priceEl = root.querySelector('[data-pb-live-price]');
      const price = priceEl?.textContent?.trim();
      // Write into the label span only — `btn.textContent = …` would also delete the
      // .loading__spinner div the button ships with.
      const label = btn.querySelector('span') || btn;
      label.textContent = price ? base + ' — ' + price : base;
    }

    root.querySelector('[data-pb-atc]')?.addEventListener('change', () => setTimeout(syncLabel, 50));
    root.addEventListener('pb:purchase-option-change', () => setTimeout(syncLabel, 50));
    syncLabel();
  }

  function initIncludedAccordion(root) {
    const included = root.querySelector('[data-pb-pdp-included]');
    if (!included) return;

    const cards = included.querySelectorAll('.pb-pdp-included__card');
    cards.forEach((card) => {
      card.addEventListener('toggle', () => {
        if (!card.open) return;
        cards.forEach((other) => {
          if (other !== card) other.open = false;
        });
      });
    });
  }

  function initPdpUgcCarousel(ugc) {
    const track = ugc.querySelector('[data-pb-pdp-ugc-track]');
    if (!track) return;

    const prevBtn = ugc.querySelector('[data-pb-pdp-ugc-prev]');
    const nextBtn = ugc.querySelector('[data-pb-pdp-ugc-next]');
    const slideCount = parseInt(ugc.dataset.pbPdpUgcCount || '0', 10);

    function scrollStep() {
      const card = track.querySelector('[data-pb-pdp-ugc-slide]');
      if (!card) return 212;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 12;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      const maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (slideCount > 2) {
      prevBtn?.addEventListener('click', () => {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      nextBtn?.addEventListener('click', () => {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      }
    });

    let isDragging = false;
    let dragStartX = 0;
    let dragScrollLeft = 0;

    track.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      if (e.target.closest('[data-pb-pdp-ugc-trigger]')) return;
      isDragging = true;
      track.classList.add('is-dragging');
      dragStartX = e.pageX;
      dragScrollLeft = track.scrollLeft;
    });

    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      updateArrows();
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      track.scrollLeft = dragScrollLeft - (e.pageX - dragStartX);
    });
  }

  function initPdpUgcVideos(root) {
    const ugc = root.querySelector('[data-pb-pdp-ugc]');
    if (!ugc || ugc.dataset.pbPdpUgcMounted === '1') return;
    ugc.dataset.pbPdpUgcMounted = '1';

    initPdpUgcCarousel(ugc);

    const track = ugc.querySelector('[data-pb-pdp-ugc-track]');
    const slides = ugc.querySelectorAll('[data-pb-pdp-ugc-slide]');

    function pauseOthers(exceptSlide) {
      slides.forEach((slide) => {
        if (slide === exceptSlide) return;
        const player = slide.querySelector('[data-pb-pdp-ugc-player]');
        if (!player) return;
        player.pause();
        player.currentTime = 0;
        slide.classList.remove('is-playing');
        const trigger = slide.querySelector('[data-pb-pdp-ugc-trigger]');
        if (trigger) {
          trigger.setAttribute('aria-label', trigger.getAttribute('data-pb-aria-play') || 'Play video');
        }
      });
    }

    slides.forEach((slide) => {
      const trigger = slide.querySelector('[data-pb-pdp-ugc-trigger]');
      const player = slide.querySelector('[data-pb-pdp-ugc-player]');
      if (!trigger) return;

      const playLabel = trigger.getAttribute('data-pb-aria-play') || 'Play video';
      const pauseLabel = trigger.getAttribute('data-pb-aria-pause') || 'Pause video';

      trigger.addEventListener('click', () => {
        const externalHref = trigger.getAttribute('data-pb-pdp-ugc-href');

        if (!player) {
          if (externalHref) window.open(externalHref, '_blank', 'noopener,noreferrer');
          return;
        }

        if (slide.classList.contains('is-playing')) {
          player.pause();
          slide.classList.remove('is-playing');
          trigger.setAttribute('aria-label', playLabel);
          return;
        }

        pauseOthers(slide);
        slide.classList.add('is-playing');
        player.play().catch(() => {
          slide.classList.remove('is-playing');
          trigger.setAttribute('aria-label', playLabel);
          if (externalHref) window.open(externalHref, '_blank', 'noopener,noreferrer');
        });
        trigger.setAttribute('aria-label', pauseLabel);
      });

      player?.addEventListener('ended', () => {
        slide.classList.remove('is-playing');
        trigger.setAttribute('aria-label', playLabel);
      });
    });

    if (track && slides.length > 1 && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) return;
            const slide = entry.target;
            const player = slide.querySelector('[data-pb-pdp-ugc-player]');
            if (!player || player.paused) return;
            player.pause();
            player.currentTime = 0;
            slide.classList.remove('is-playing');
            const trigger = slide.querySelector('[data-pb-pdp-ugc-trigger]');
            trigger?.setAttribute('aria-label', trigger.getAttribute('data-pb-aria-play') || 'Play video');
          });
        },
        { root: track, threshold: 0.45 }
      );
      slides.forEach((slide) => io.observe(slide));
    }
  }

  function initBrowniesRoot(root) {
    if (!root || pbBrowniesRootsInited.has(root)) return;
    pbBrowniesRootsInited.add(root);

    // Each init is isolated. These used to run as a bare sequence, so a throw in any one
    // of them (a missing element on a template that doesn't use every block) silently
    // killed every init after it — including the upsell ATC binding — with nothing in
    // the console to say so.
    [
      ['gallery', initGallery],
      ['purchaseOptions', initPurchaseOptions],
      ['staticSizePicker', initStaticSizePicker],
      ['upsell', initUpsell],
      ['ajaxAtc', initAjaxAtc],
      ['atcLabel', initAtcLabel],
      ['includedAccordion', initIncludedAccordion],
      ['ugcVideos', initPdpUgcVideos],
    ].forEach(([name, fn]) => {
      try {
        fn(root);
      } catch (e) {
        console.error('[PB PDP] init "' + name + '" failed:', e);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function pbBrowniesVariantLiveOnly(pbPayload) {
        if (String(pbPayload?.data?.sectionId) !== String(root.dataset.section)) return;
        if (root.querySelector('[data-pb-purchase-options]')) return;
        const variant = pbPayload?.data?.variant;
        const live = root.querySelector('[data-pb-live-price]');
        if (!variant || !live) return;
        // Keep the stored base unit in sync, then recompute including upsell add-ons.
        live.dataset.pbUnitCents = String(pbParseCents(variant.price, 0));
        const fmt = live.dataset.pbMoneyFormat || '';
        const q = pbGetFormQuantity(root);
        live.textContent = pbFormatMoney(pbParseCents(variant.price, 0) * q + pbGetUpsellCents(root), fmt);
        root.dispatchEvent(new CustomEvent('pb:purchase-option-change', { bubbles: true }));
      });
    }
  }

  document.addEventListener('product-info:loaded', (e) => {
    const el = e.target;
    if (!el || typeof el.matches !== 'function' || !el.matches('[data-pb-pdp-brownies]')) return;
    initBrowniesRoot(el);
  });

  document.querySelectorAll('[data-pb-pdp-brownies]').forEach(initBrowniesRoot);
})();
